import { isNumeric } from '../utils'

const convertStringToPx = (value: string | number | undefined) => {
    if (isNumeric(value)) {
        return value + 'px'
    }
    return value
}
export default convertStringToPx
